import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { CardProps } from "../../types";

export function Card({
  children,
  className,
  title,
  extra,
  bordered = true,
  hoverable = false,
  loading = false,
}: CardProps) {
  return (
    <div
      className={twMerge(
        clsx(
          "bg-white rounded-md shadow-card",
          bordered && "border border-gray-200",
          hoverable && "hover:shadow-logincard duration-200 cursor-pointer",
          loading && "animate-pulse",
          className,
        ),
      )}
    >
      {(title || extra) && (
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          {title && (
            <h3 className="text-lg font-semibold text-customBlack">{title}</h3>
          )}
          {extra && <div>{extra}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
}

export default Card;
